import type { ErpModule } from '@/api/platform.api';

/** Per-application accent for sidebar active states */
export const APP_ACCENT: Record<ErpModule, 'violet' | 'blue' | 'emerald' | 'amber' | 'rose' | 'cyan' | 'slate'> = {
  POS: 'violet',
  PROCUREMENT: 'amber',
  CRM: 'blue',
  LEAD_GEN: 'blue',
  MARKETING: 'rose',
  HR: 'emerald',
  FINANCE: 'amber',
  PROJECTS: 'cyan',
  DESK: 'rose',
  SOCIAL: 'cyan',
  INVENTORY: 'violet',
  LOYALTY: 'violet',
  REPORTING: 'slate',
  ANALYTICS: 'slate',
  PAYROLL: 'emerald',
  DELIVERY: 'slate',
  ECOMMERCE: 'slate',
  WAREHOUSE: 'violet',
};

export type AppAccent = (typeof APP_ACCENT)[ErpModule];

/** Colored KPI icon backgrounds (matches PageTitleIcon / dashboard header style). */
export const KPI_ICON_TONE_CLASSES = [
  'bg-primary-50 text-primary-700 dark:bg-primary-950/50 dark:text-primary-300',
  'bg-violet-50 text-violet-700 dark:bg-violet-950/50 dark:text-violet-300',
  'bg-blue-50 text-blue-700 dark:bg-blue-950/50 dark:text-blue-300',
  'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300',
  'bg-amber-50 text-amber-800 dark:bg-amber-950/50 dark:text-amber-300',
  'bg-rose-50 text-rose-700 dark:bg-rose-950/50 dark:text-rose-300',
  'bg-cyan-50 text-cyan-800 dark:bg-cyan-950/50 dark:text-cyan-300',
  'bg-indigo-50 text-indigo-700 dark:bg-indigo-950/50 dark:text-indigo-300',
] as const;

export function getKpiIconClassName(index = 0): string {
  return KPI_ICON_TONE_CLASSES[Math.abs(index) % KPI_ICON_TONE_CLASSES.length];
}

const ACCENT_ICON_CLASS: Record<AppAccent, string> = {
  violet: KPI_ICON_TONE_CLASSES[0],
  blue: KPI_ICON_TONE_CLASSES[2],
  emerald: KPI_ICON_TONE_CLASSES[3],
  amber: KPI_ICON_TONE_CLASSES[4],
  rose: KPI_ICON_TONE_CLASSES[5],
  cyan: KPI_ICON_TONE_CLASSES[6],
  slate: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
};

export function getModuleAccentIconClass(module: ErpModule): string {
  return ACCENT_ICON_CLASS[APP_ACCENT[module] ?? 'violet'];
}
